import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';
import { RuleCompositionData } from './ruleComposition';

export type RuleCompositionOfferState = {
  isOpen: boolean;
  data: RuleCompositionData | null;
};

const initialState: RuleCompositionOfferState = { isOpen: false, data: null };

const slice = createSlice({
  name: 'ipa.priceManager.modals.ruleCompositionOffer',
  initialState,
  reducers: {
    SET_IS_OPEN: (state, action: PayloadAction<RuleCompositionOfferState['isOpen']>) => {
      state.isOpen = action.payload;
    },
    SET_DATA: (state, action: PayloadAction<RuleCompositionOfferState['data']>) => {
      state.data = action.payload;
    },
  },
});

export const { SET_IS_OPEN, SET_DATA } = slice.actions;

export default slice.reducer;

export const selectorRuleCompositionOffer = (state: RootState) => {
  return state.ipa.priceManager.modals.ruleCompositionOffer;
};
